import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "helper/global";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PREFERENCE_LOAD:
      return updateObject(state, {
        ...action,
      });

    default:
      return state;
  }
};

export default reducer;
